import React from 'react';
import { BsCheckCircle, BsClock } from "react-icons/bs";

const appointments = [
    {
        "Appointment ID": "AP0001",
        "Patient Name": "Janu",
        "Time Slot": "3:00 pm",
        "Visit Type": "In-person",
        "Doctor": "DR. Rohan",
        "Reason for Visit": "General Checkup",
        "Appointment Date": "03-01-2025",
        "Assigned Room": "03",
        "Reminder Status": "Reminder Sent"
      },
      {
        "Appointment ID": "AP0002",
        "Patient Name": "Lokesh",
        "Time Slot": "10:00 am",
        "Visit Type": "Virtual",
        "Doctor": "DR. Samantha ",
        "Reason for Visit": "Follow-up",
        "Appointment Date": "03-02-2025",
        "Assigned Room": "N/A",
        "Reminder Status": "Reminder Pending"
      },
      {
        "Appointment ID": "AP0003",
        "Patient Name": "Kameswari",
        "Time Slot": "2:30 pm",
        "Visit Type": "In-person",
        "Doctor": "DR. Sanjay",
        "Reason for Visit": "General Checkup",
        "Appointment Date": "03-01-2025",
        "Assigned Room": "05",
        "Reminder Status": "Reminder Sent"
      },
      {
        "Appointment ID": "AP0004",
        "Patient Name": "Revathi",
        "Time Slot": "11:15 am",
        "Visit Type": "Virtual",
        "Doctor": "DR. Sita",
        "Reason for Visit": "Diagnosis",
        "Appointment Date": "03-03-2025",
        "Assigned Room": "N/A",
        "Reminder Status": "Reminder Pending"
      },
      {
        "Appointment ID": "AP0005",
        "Patient Name": "Lakshmi",
        "Time Slot": "4:45 pm",
        "Visit Type": "In-person",
        "Doctor": "DR. Samantha ",
        "Reason for Visit": "General Checkup",
        "Appointment Date": "03-01-2025",
        "Assigned Room": "06",
        "Reminder Status": "Reminder Sent"
      },
      {
        "Appointment ID": "AP0006",
        "Patient Name": "Sudhakar",
        "Time Slot": "1:00 pm",
        "Visit Type": "Virtual",
        "Doctor": "DR. Lakshmi",
        "Reason for Visit": "Follow-up",
        "Appointment Date": "03-02-2025",
        "Assigned Room": "N/A",
        "Reminder Status": "Reminder Pending"
      },
      {
        "Appointment ID": "AP0007",
        "Patient Name": "Anuradha",
        "Time Slot": "3:30 pm",
        "Visit Type": "In-person",
        "Doctor": "DR. Syam",
        "Reason for Visit": "Diagnosis",
        "Appointment Date": "03-01-2025",
        "Assigned Room": "07",
        "Reminder Status": "Reminder Sent"
      },
      {
        "Appointment ID": "AP0008",
        "Patient Name": "Ritish",
        "Time Slot": "9:00 am",
        "Visit Type": "Virtual",
        "Doctor": "DR. Vishnavi",
        "Reason for Visit": "Follow-up",
        "Appointment Date": "03-03-2025",
        "Assigned Room": "N/A",
        "Reminder Status": "Reminder Pending"
      },
      {
        "Appointment ID": "AP0009",
        "Patient Name": "Shivam",
        "Time Slot": "12:30 pm",
        "Visit Type": "In-person",
        "Doctor": "DR. Priya",
        "Reason for Visit": "General Checkup",
        "Appointment Date": "03-01-2025",
        "Assigned Room": "04",
        "Reminder Status": "Reminder Sent"
      },
      {
        "Appointment ID": "AP0010",
        "Patient Name": "Hema",
        "Time Slot": "5:15 pm",
        "Visit Type": "Virtual",
        "Doctor": "DR. Ravindra",
        "Reason for Visit": "Diagnosis",
        "Appointment Date": "03-03-2025",
        "Assigned Room": "N/A",
        "Reminder Status": "Reminder Pending"
      },
      {
        "Appointment ID": "AP0011",
        "Patient Name": "Raju",
        "Time Slot": "8:45 am",
        "Visit Type": "In-person",
        "Doctor": "DR. Sravani",
        "Reason for Visit": "Follow-up",
        "Appointment Date": "03-01-2025",
        "Assigned Room": "02",
        "Reminder Status": "Reminder Sent"
      }
  ];

const UpcomingAppointmentsGrid = () => {
  return (
    <div className="row">
      {appointments.map((appointment) => (
        <div className="col-sm-4 mb-3" key={appointment["Appointment ID"]}>
          <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #ddd" }}>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center pb-2" style={{ borderBottom: "2px dashed #6b93b0", paddingBottom: "8px" }}>
                <h6 style={{ color: "grey", fontWeight: "bold", fontSize: "12px", margin: 0 }}>{appointment["Appointment ID"]}</h6>
                <div className="d-flex align-items-center">
                  {appointment["Reminder Status"] === "Reminder Sent" ? (
                    <span className="badge bg-success" style={{ fontSize: "12px" }}>Reminder Sent</span>
                  ) : (
                    <span className="badge bg-warning text-dark" style={{ fontSize: "12px" }}>Reminder Pending</span>
                  )}
                </div>
              </div>

              <div className="mt-2 mb-3">
                <div className="d-flex justify-content-between">
                  <p className="mt-2 fw-bold" style={{ fontSize: "12px" }}>Patient Name</p>
                  <p className="mb-0 me-3" style={{ fontSize: "12px" }}>{appointment["Patient Name"]}</p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="mt-2 fw-bold" style={{ fontSize: "12px" }}>Reason for Visit</p>
                  <p className="mb-0 me-3 fw-medium" style={{ color: appointment["Reason for Visit"] === 'General Checkup' ? 'green' : appointment["Reason for Visit"] === 'Follow-up' ? '#FFB800' : '#1AA7FF', fontSize: "12px" }}>{appointment["Reason for Visit"]}</p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="mt-2 fw-bold" style={{ fontSize: "12px" }}>Assigned Room</p>
                  <p className="mb-0 me-3" style={{ fontSize: "12px" }}>{appointment["Assigned Room"]}</p>
                </div>
              </div>

              <div className="card" style={{ borderColor: "#09940b" }}>
                <div className="card-header" style={{ borderColor: "#09940b", backgroundColor: "rgba(34, 201, 37,0.3)", fontWeight: 600 }}>{appointment.Doctor}</div>
                <div className="card-body">
                  <div className="mt-2">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center">
                        <BsCheckCircle color="#2ac7b2" size={16} />
                        <p className="mb-0 ms-2 fw-bold" style={{ fontSize: "12px" }}>Appointment Date</p>
                      </div>
                      <p className="mb-0 text-end" style={{ fontSize: "12px" }}>{appointment["Appointment Date"]}</p>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <div className="d-flex align-items-center">
                        <BsClock color="#36d413" size={16} />
                        <p className="mb-0 ms-2 fw-bold" style={{ fontSize: "12px" }}>Time Slot</p>
                      </div>
                      <p className="mb-0 text-end" style={{ fontSize: "12px" }}>{appointment["Time Slot"]}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default UpcomingAppointmentsGrid